import { Box, Flex, Text, useDisclosure } from '@chakra-ui/react';
import { CompanyProjectDisplay } from './CompanyProjectDisplay';
import { useCompanyProjectsQuery } from './api/useCompanyProjectsQuery';
import { BaseAlert, BaseButton, BaseButtonText, BaseDialog } from '@invara-dev/react-base';

type Props = {
  companyId?: number;
  checkOutDate?: string;
  checkInDate?: string;
  cityNames?: string[];
  cityIds?: number[];
};

export const CompanyProjectNotification = ({ cityIds, companyId, checkInDate, checkOutDate, cityNames }: Props) => {
  const disclosure = useDisclosure();
  const companyProjects = useCompanyProjectsQuery(cityNames, cityIds, checkInDate, checkOutDate, companyId);
  if (!companyProjects.data) {
    return <></>;
  }
  if (companyProjects.data.length == 0) {
    return <></>;
  }
  return (
    <Box w={'100%'}>
      <BaseAlert status={'error'}>
        <Flex w={'100%'} justifyContent={'space-between'}>
          <Box>
            <Text>Company currently has projects in this city.</Text>
            <Text>Please review before booking.</Text>
          </Box>
          <BaseButton marginLeft={'auto'} size='sm' onClick={disclosure.onOpen}>
            Details
          </BaseButton>
        </Flex>
      </BaseAlert>

      <BaseDialog
        disclosure={disclosure}
        header={'Company Projects'}
        size='lg'
        footerRender={<BaseButton onClick={disclosure.onClose} buttonText={BaseButtonText.OK} />}>
        <CompanyProjectDisplay projects={companyProjects.data} />
      </BaseDialog>
    </Box>
  );
};
